// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var React = require("react");
var Common = require("../utils/Common.res.js");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var Core__JSON = require("@rescript/core/src/Core__JSON.res.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Core__Option = require("@rescript/core/src/Core__Option.res.js");
var Raw_js_utils = require("../utils/Raw_js_utils.res.js");
var Core__Promise = require("@rescript/core/src/Core__Promise.res.js");
var MM_api_macros = require("./MM_api_macros.res.js");
var Warning_modal = require("../ui-utils/Warning_modal.res.js");
var Belt_MapString = require("rescript/lib/js/belt_MapString.js");
var MM_macros_mmj2 = require("./macros/MM_macros_mmj2.res.js");
var Expln_React_Row = require("../../rescript-utils/main/react-mui-components/Expln_React_Row.res.js");
var MM_react_common = require("../ui-utils/MM_react_common.res.js");
var Expln_React_Modal = require("../../rescript-utils/main/react-components/Expln_React_Modal.res.js");
var List = require("@mui/material/List").default;
var Belt_HashMapString = require("rescript/lib/js/belt_HashMapString.js");
var Expln_React_Column = require("../../rescript-utils/main/react-mui-components/Expln_React_Column.res.js");
var Expln_React_common = require("../../rescript-utils/main/Expln_React_common.res.js");
var Expln_utils_common = require("../../rescript-utils/main/Expln_utils_common.res.js");
var Paper = require("@mui/material/Paper").default;
var Expln_utils_promise = require("../../rescript-utils/main/Expln_utils_promise.res.js");
var JsxPPXReactSupportU = require("rescript/lib/js/jsxPPXReactSupportU.js");
var Local_storage_utils = require("../ui-utils/Local_storage_utils.res.js");
var Button = require("@mui/material/Button").default;
var Select = require("@mui/material/Select").default;
var Expln_utils_jsonParse = require("../../rescript-utils/main/Expln_utils_jsonParse.res.js");
var Checkbox = require("@mui/material/Checkbox").default;
var ListItem = require("@mui/material/ListItem").default;
var MenuItem = require("@mui/material/MenuItem").default;
var TextField = require("@mui/material/TextField").default;
var IconButton = require("@mui/material/IconButton").default;
var MM_macros_set_mm_example = require("./macros/MM_macros_set_mm_example.res.js");
var FormControl = require("@mui/material/FormControl").default;
var ListItemText = require("@mui/material/ListItemText").default;
var Warning = require("@mui/icons-material/Warning").default;
var ListItemButton = require("@mui/material/ListItemButton").default;
var FormControlLabel = require("@mui/material/FormControlLabel").default;

var scriptCache = Belt_HashMapString.make(1);

function getScriptCacheKey(macroModuleName, script) {
  return macroModuleName + " ### " + script;
}

function runAsyncScript(macroModuleName, script) {
  var key = getScriptCacheKey(macroModuleName, script);
  var result = Belt_HashMapString.get(scriptCache, key);
  if (result !== undefined) {
    return Promise.resolve(result);
  }
  var title = "Executing the script for '" + macroModuleName + "'";
  var msg = Raw_js_utils.invokeExnFunc(title, (function () {
          return Raw_js_utils.executeAsyncFunctionBody(script);
        }));
  var tmp;
  tmp = msg.TAG === "Ok" ? Core__Promise.$$catch(msg._0.then(function (param) {
              return {
                      TAG: "Ok",
                      _0: undefined
                    };
            }), (function (exn) {
            var match = Common.jsErrorToExnData(exn);
            var stack = match.stack;
            return Promise.resolve({
                        TAG: "Error",
                        _0: title + ": " + match.msg + "." + (
                          stack !== "" ? "\n" + stack : ""
                        )
                      });
          })) : Promise.resolve({
          TAG: "Error",
          _0: msg._0
        });
  return tmp.then(function (res) {
              Belt_HashMapString.set(scriptCache, key, res);
              return res;
            });
}

function removeStaleDataFromScriptCache(st) {
  var validKeys = [];
  Belt_MapString.forEach(st.macroModules, (function (modName, mod) {
          if (mod.isActive) {
            validKeys.push(getScriptCacheKey(modName, mod.scriptText));
            return ;
          }
          
        }));
  var allKeys = Belt_HashMapString.keysToArray(scriptCache);
  allKeys.forEach(function (key) {
        if (!validKeys.includes(key)) {
          return Belt_HashMapString.remove(scriptCache, key);
        }
        
      });
}

function textToScript(text) {
  return text.replaceAll("[!@#]backtick[!@#]", "`").replaceAll("[!@#]dollar[!@#]", "$").replaceAll("[!@#]backslash[!@#]", "\\");
}

var $$location = window.location;

var showIncompleteMacros;

if ($$location == null) {
  showIncompleteMacros = false;
} else {
  var href = $$location.href;
  if (href == null) {
    showIncompleteMacros = false;
  } else {
    var hrefStr = Core__JSON.Decode.string(href);
    showIncompleteMacros = hrefStr !== undefined ? hrefStr.startsWith("http://localhost:") || hrefStr.startsWith("https://expln.github.io/lamp/dev/") : false;
  }
}

var predefinedMacroModuleScripts = Belt_HashMapString.fromArray(Belt_Array.concatMany([
          [[
              "default set.mm macros",
              textToScript(MM_macros_set_mm_example.setMmExampleMacros)
            ]],
          showIncompleteMacros ? [[
                "MMJ2",
                textToScript(MM_macros_mmj2.mmj2Macros)
              ]] : []
        ]));

function isPredefinedMacroModule(macroModuleName) {
  return Belt_HashMapString.has(predefinedMacroModuleScripts, macroModuleName);
}

function stateToStateLocStor(st) {
  return {
          selectedMacroModuleName: st.selectedMacroModuleName,
          macroModules: Belt_MapString.toArray(st.macroModules).filter(function (param) {
                  return param[1].scriptText.trim() !== "";
                }).map(function (param) {
                var mod = param[1];
                var modName = param[0];
                return {
                        name: modName,
                        isActive: mod.isActive,
                        scriptText: Belt_HashMapString.has(predefinedMacroModuleScripts, modName) ? "" : mod.scriptText
                      };
              })
        };
}

function makeEmptyStateLocStor() {
  return {
          selectedMacroModuleName: "",
          macroModules: []
        };
}

var macrosLocStorKey = "macros";

function runActiveScripts(macroModules) {
  return Promise.all(Belt_HashMapString.toArray(macroModules).map(function (param) {
                    var mod = param[1];
                    var modName = param[0];
                    if (mod.isActive && mod.scriptText.trim() !== "") {
                      return runAsyncScript(modName, mod.scriptText).then(function (execRes) {
                                  var scriptExecutionErr;
                                  scriptExecutionErr = execRes.TAG === "Ok" ? undefined : execRes._0;
                                  var macros = Core__Option.getOr(MM_api_macros.listRegisteredMacrosInModule(modName), []);
                                  return [
                                          modName,
                                          {
                                            nameEdit: mod.nameEdit,
                                            isActive: mod.isActive,
                                            isActiveEdit: mod.isActiveEdit,
                                            scriptText: mod.scriptText,
                                            scriptTextEdit: mod.scriptTextEdit,
                                            scriptExecutionErr: scriptExecutionErr,
                                            macros: macros
                                          }
                                        ];
                                });
                    } else {
                      return Promise.resolve([
                                  modName,
                                  mod
                                ]);
                    }
                  })).then(Belt_HashMapString.fromArray);
}

function readStateFromLocStor() {
  var macroModules = Belt_HashMapString.fromArray(Belt_HashMapString.toArray(predefinedMacroModuleScripts).map(function (param) {
            var script = param[1];
            var modName = param[0];
            return [
                    modName,
                    {
                      nameEdit: modName,
                      isActive: false,
                      isActiveEdit: false,
                      scriptText: script,
                      scriptTextEdit: script,
                      scriptExecutionErr: undefined,
                      macros: []
                    }
                  ];
          }));
  var jsonStr = Local_storage_utils.locStorReadString(macrosLocStorKey);
  var stateLocStor;
  if (jsonStr !== undefined) {
    var stateLocStor$1 = Expln_utils_jsonParse.parseJson(jsonStr, (function (__x) {
            return Expln_utils_jsonParse.asObj(__x, (function (d) {
                          return {
                                  selectedMacroModuleName: Expln_utils_jsonParse.str(d, "selectedMacroModuleName", undefined, undefined),
                                  macroModules: Expln_utils_jsonParse.arr(d, "macroModules", (function (__x) {
                                          return Expln_utils_jsonParse.asObj(__x, (function (d) {
                                                        return {
                                                                name: Expln_utils_jsonParse.str(d, "name", (function (n) {
                                                                        return {
                                                                                TAG: "Ok",
                                                                                _0: n.trim()
                                                                              };
                                                                      }), undefined),
                                                                isActive: Expln_utils_jsonParse.bool(d, "isActive", undefined, undefined),
                                                                scriptText: Expln_utils_jsonParse.str(d, "scriptText", undefined, undefined)
                                                              };
                                                      }), undefined, undefined);
                                        }), undefined, undefined)
                                };
                        }), undefined, undefined);
          }), undefined, undefined);
    stateLocStor = stateLocStor$1.TAG === "Ok" ? stateLocStor$1._0 : ({
          selectedMacroModuleName: "",
          macroModules: []
        });
  } else {
    stateLocStor = {
      selectedMacroModuleName: "",
      macroModules: []
    };
  }
  stateLocStor.macroModules.forEach(function (mod) {
        var existingMod = Belt_HashMapString.get(macroModules, mod.name);
        if (existingMod !== undefined) {
          if (Belt_HashMapString.has(predefinedMacroModuleScripts, mod.name)) {
            return Belt_HashMapString.set(macroModules, mod.name, {
                        nameEdit: existingMod.nameEdit,
                        isActive: mod.isActive,
                        isActiveEdit: mod.isActive,
                        scriptText: existingMod.scriptText,
                        scriptTextEdit: existingMod.scriptTextEdit,
                        scriptExecutionErr: existingMod.scriptExecutionErr,
                        macros: existingMod.macros
                      });
          } else {
            return ;
          }
        } else {
          return Belt_HashMapString.set(macroModules, mod.name, {
                      nameEdit: mod.name,
                      isActive: mod.isActive,
                      isActiveEdit: mod.isActive,
                      scriptText: mod.scriptText,
                      scriptTextEdit: mod.scriptText,
                      scriptExecutionErr: undefined,
                      macros: []
                    });
        }
      });
  MM_api_macros.listRegisteredMacroModules().forEach(function (registeredModName) {
        if (!Belt_HashMapString.has(macroModules, registeredModName)) {
          return Belt_HashMapString.set(macroModules, registeredModName, {
                      nameEdit: registeredModName,
                      isActive: true,
                      isActiveEdit: true,
                      scriptText: "",
                      scriptTextEdit: "",
                      scriptExecutionErr: undefined,
                      macros: Core__Option.getOr(MM_api_macros.listRegisteredMacrosInModule(registeredModName), [])
                    });
        }
        
      });
  var emptyNames = [];
  Belt_HashMapString.forEach(macroModules, (function (modName, param) {
          if (modName.trim() === "") {
            emptyNames.push(modName);
            return ;
          }
          
        }));
  emptyNames.forEach(function (modName) {
        Belt_HashMapString.remove(macroModules, modName);
      });
  return runActiveScripts(macroModules).then(function (macroModules) {
              var allLoadedMacroModules = Belt_HashMapString.keysToArray(macroModules);
              return {
                      selectedMacroModuleName: Core__Option.getOr(allLoadedMacroModules.find(function (n) {
                                return n === stateLocStor.selectedMacroModuleName;
                              }), Core__Option.getExn(allLoadedMacroModules[0], "MM_cmp_macros.readStateFromLocStor.1")),
                      macroModules: Belt_MapString.fromArray(Belt_HashMapString.toArray(macroModules))
                    };
            });
}

function reloadState(st) {
  removeStaleDataFromScriptCache(st);
  Local_storage_utils.locStorWriteString(macrosLocStorKey, Expln_utils_common.stringify(stateToStateLocStor(st)));
  return readStateFromLocStor();
}

function addNewMacroModule(st) {
  return {
          selectedMacroModuleName: "",
          macroModules: Belt_MapString.set(st.macroModules, "", {
                nameEdit: "New macros",
                isActive: true,
                isActiveEdit: true,
                scriptText: "",
                scriptTextEdit: "",
                scriptExecutionErr: undefined,
                macros: []
              })
        };
}

function deleteMacroModule(st, moduleName) {
  if (Belt_HashMapString.has(predefinedMacroModuleScripts, moduleName)) {
    return Promise.resolve({
                TAG: "Error",
                _0: "Cannot delete a predefined macro module."
              });
  } else {
    MM_api_macros.unregisterMacroModule(moduleName);
    return reloadState({
                  selectedMacroModuleName: st.selectedMacroModuleName,
                  macroModules: Belt_MapString.remove(st.macroModules, moduleName)
                }).then(function (st) {
                return {
                        TAG: "Ok",
                        _0: st
                      };
              });
  }
}

function saveEdits(st, moduleName) {
  var mod = Belt_MapString.get(st.macroModules, moduleName);
  if (mod !== undefined) {
    if (Belt_HashMapString.has(predefinedMacroModuleScripts, moduleName) && (moduleName !== mod.nameEdit || mod.scriptText !== mod.scriptTextEdit)) {
      return Promise.resolve({
                  TAG: "Error",
                  _0: "Cannot update a predefined macro module."
                });
    } else if (moduleName !== mod.nameEdit && Belt_MapString.has(st.macroModules, mod.nameEdit)) {
      return Promise.resolve({
                  TAG: "Error",
                  _0: "A module with name \"" + mod.nameEdit + "\" already exists. Please choose another name."
                });
    } else if (mod.nameEdit.trim() === "") {
      return Promise.resolve({
                  TAG: "Error",
                  _0: "A module name must not be empty."
                });
    } else if (mod.scriptTextEdit.trim() === "") {
      return Promise.resolve({
                  TAG: "Error",
                  _0: "The script must not be empty."
                });
    } else {
      if (!mod.isActiveEdit) {
        MM_api_macros.unregisterMacroModule(moduleName);
      }
      return reloadState({
                    selectedMacroModuleName: moduleName === st.selectedMacroModuleName ? mod.nameEdit : st.selectedMacroModuleName,
                    macroModules: Belt_MapString.set(Belt_MapString.remove(st.macroModules, moduleName), mod.nameEdit, {
                          nameEdit: mod.nameEdit,
                          isActive: mod.isActiveEdit,
                          isActiveEdit: mod.isActiveEdit,
                          scriptText: mod.scriptTextEdit,
                          scriptTextEdit: mod.scriptTextEdit,
                          scriptExecutionErr: mod.scriptExecutionErr,
                          macros: mod.macros
                        })
                  }).then(function (st) {
                  return {
                          TAG: "Ok",
                          _0: st
                        };
                });
    }
  } else {
    return Promise.resolve({
                TAG: "Ok",
                _0: st
              });
  }
}

function setNameEdit(st, moduleName, nameEdit) {
  if (Belt_HashMapString.has(predefinedMacroModuleScripts, moduleName)) {
    return {
            TAG: "Error",
            _0: "Cannot update a predefined macro module."
          };
  }
  var mod = Belt_MapString.get(st.macroModules, moduleName);
  if (mod !== undefined) {
    return {
            TAG: "Ok",
            _0: {
              selectedMacroModuleName: st.selectedMacroModuleName,
              macroModules: Belt_MapString.set(st.macroModules, moduleName, {
                    nameEdit: nameEdit,
                    isActive: mod.isActive,
                    isActiveEdit: mod.isActiveEdit,
                    scriptText: mod.scriptText,
                    scriptTextEdit: mod.scriptTextEdit,
                    scriptExecutionErr: mod.scriptExecutionErr,
                    macros: mod.macros
                  })
            }
          };
  } else {
    return {
            TAG: "Ok",
            _0: st
          };
  }
}

function setIsActiveEdit(st, moduleName, isActiveEdit) {
  var mod = Belt_MapString.get(st.macroModules, moduleName);
  if (mod !== undefined) {
    return {
            TAG: "Ok",
            _0: {
              selectedMacroModuleName: st.selectedMacroModuleName,
              macroModules: Belt_MapString.set(st.macroModules, moduleName, {
                    nameEdit: mod.nameEdit,
                    isActive: mod.isActive,
                    isActiveEdit: isActiveEdit,
                    scriptText: mod.scriptText,
                    scriptTextEdit: mod.scriptTextEdit,
                    scriptExecutionErr: mod.scriptExecutionErr,
                    macros: mod.macros
                  })
            }
          };
  } else {
    return {
            TAG: "Ok",
            _0: st
          };
  }
}

function setScriptTextEdit(st, moduleName, scriptTextEdit) {
  if (Belt_HashMapString.has(predefinedMacroModuleScripts, moduleName)) {
    return {
            TAG: "Error",
            _0: "Cannot update a predefined macro module."
          };
  }
  var mod = Belt_MapString.get(st.macroModules, moduleName);
  if (mod !== undefined) {
    return {
            TAG: "Ok",
            _0: {
              selectedMacroModuleName: st.selectedMacroModuleName,
              macroModules: Belt_MapString.set(st.macroModules, moduleName, {
                    nameEdit: mod.nameEdit,
                    isActive: mod.isActive,
                    isActiveEdit: mod.isActiveEdit,
                    scriptText: mod.scriptText,
                    scriptTextEdit: scriptTextEdit,
                    scriptExecutionErr: mod.scriptExecutionErr,
                    macros: mod.macros
                  })
            }
          };
  } else {
    return {
            TAG: "Ok",
            _0: st
          };
  }
}

function resetEditsForMacroModule(st, moduleName) {
  if (Belt_HashMapString.has(predefinedMacroModuleScripts, moduleName)) {
    return Promise.resolve({
                TAG: "Error",
                _0: "Cannot update a predefined macro module."
              });
  }
  var mod = Belt_MapString.get(st.macroModules, moduleName);
  if (mod !== undefined) {
    return reloadState({
                  selectedMacroModuleName: st.selectedMacroModuleName,
                  macroModules: Belt_MapString.set(st.macroModules, moduleName, {
                        nameEdit: moduleName,
                        isActive: mod.isActive,
                        isActiveEdit: mod.isActive,
                        scriptText: mod.scriptText,
                        scriptTextEdit: mod.scriptText,
                        scriptExecutionErr: mod.scriptExecutionErr,
                        macros: mod.macros
                      })
                }).then(function (st) {
                return {
                        TAG: "Ok",
                        _0: st
                      };
              });
  } else {
    return Promise.resolve({
                TAG: "Ok",
                _0: st
              });
  }
}

function setSelectedMacroModuleName(st, newSelectedMacroModuleName) {
  var match = Belt_MapString.get(st.macroModules, newSelectedMacroModuleName);
  if (match !== undefined) {
    return reloadState({
                  selectedMacroModuleName: newSelectedMacroModuleName,
                  macroModules: st.macroModules
                }).then(function (st) {
                return {
                        TAG: "Ok",
                        _0: st
                      };
              });
  } else {
    return Promise.resolve({
                TAG: "Ok",
                _0: st
              });
  }
}

var expBtnBaseStyle = {
  border: "1px solid",
  color: "grey",
  cursor: "pointer",
  display: "block",
  fontFamily: "courier",
  fontSize: "10px",
  marginTop: "13px",
  marginRight: "3px",
  padding: "1px 3px 0px 2px"
};

var warningText = "\n    Please be careful with what JavaScript code you use for macros. \n    This code will be executed by your browser \"as is\" meaning no safety measures will be taken to protect your browser from hurmful code.\n    Before putting any code into this dialog please make sure you understand what that code does or make sure the code is not harmful.\n";

function useStateRenderer(modalRef, state, updateState, updateSelectedMacroModule, updateStateAsync, updateSelectedMacroModuleAsync, onClose) {
  var match = Local_storage_utils.useStateFromLocalStorageBool("macros-dialog-is-expanded", false);
  var setIsExpanded = match[1];
  var isExpanded = match[0];
  var match$1 = Local_storage_utils.useStateFromLocalStorageBool("custom-macros-js-warning-hide", false);
  var setHideWarning = match$1[1];
  var hideWarning = match$1[0];
  var selectedMacroModule = Belt_MapString.get(state.macroModules, state.selectedMacroModuleName);
  var selectedMacroModuleIsReadOnly = Belt_HashMapString.has(predefinedMacroModuleScripts, state.selectedMacroModuleName);
  var actShowWarning = function () {
    Expln_utils_promise.promiseMap(Expln_React_Modal.openModal(modalRef, (function () {
                return null;
              })), (function (modalId) {
            Expln_React_Modal.updateModal(modalRef, modalId, (function () {
                    return React.createElement(Warning_modal.make, {
                                title: "Security warning",
                                warningText: warningText,
                                hideInit: hideWarning,
                                onHideChange: (function (b) {
                                    setHideWarning(function (param) {
                                          return b;
                                        });
                                  }),
                                onClose: (function () {
                                    Expln_React_Modal.closeModal(modalRef, modalId);
                                  })
                              });
                  }));
          }));
  };
  React.useEffect((function () {
          if (Belt_MapString.size(state.macroModules) > 0 && !selectedMacroModuleIsReadOnly && !hideWarning && isExpanded) {
            actShowWarning();
          }
          
        }), [selectedMacroModuleIsReadOnly]);
  var thereAreChangesInSelectedMacroModule = Belt_Option.getWithDefault(Belt_Option.map(selectedMacroModule, (function (mod) {
              if (state.selectedMacroModuleName !== mod.nameEdit || mod.isActive !== mod.isActiveEdit) {
                return true;
              } else {
                return mod.scriptText !== mod.scriptTextEdit;
              }
            })), false);
  var actSelectedMacroModuleNameChange = function (newSelectedMacroModuleName) {
    updateStateAsync(function (__x) {
          return setSelectedMacroModuleName(__x, newSelectedMacroModuleName);
        });
  };
  var actSetNameEdit = function (nameEdit) {
    updateSelectedMacroModule(function (st, moduleName) {
          return setNameEdit(st, moduleName, nameEdit);
        });
  };
  var actSetIsActiveEdit = function (isActiveEdit) {
    updateSelectedMacroModule(function (st, moduleName) {
          return setIsActiveEdit(st, moduleName, isActiveEdit);
        });
  };
  var actSetScriptTextEdit = function (scriptTextEdit) {
    updateSelectedMacroModule(function (st, moduleName) {
          return setScriptTextEdit(st, moduleName, scriptTextEdit);
        });
  };
  var actSaveEdits = function () {
    updateSelectedMacroModuleAsync(function (st, moduleName) {
          return saveEdits(st, moduleName);
        });
  };
  var activateSelectedMacroModule = function () {
    updateSelectedMacroModuleAsync(function (st, moduleName) {
          var msg = setIsActiveEdit(st, moduleName, true);
          if (msg.TAG === "Ok") {
            return saveEdits(msg._0, moduleName);
          } else {
            return Promise.resolve({
                        TAG: "Error",
                        _0: msg._0
                      });
          }
        });
  };
  var actDeleteSelectedMacroModule = function () {
    if (selectedMacroModule !== undefined) {
      MM_react_common.openOkCancelDialog(modalRef, undefined, undefined, undefined, "Delete \"" + state.selectedMacroModuleName + "\" module of macros?", undefined, undefined).then(function (confirmed) {
            if (confirmed) {
              return updateSelectedMacroModuleAsync(function (st, moduleName) {
                          return deleteMacroModule(st, moduleName);
                        });
            }
            
          });
      return ;
    }
    
  };
  var actAddNewMacroModule = function () {
    updateState(function (st) {
          return {
                  TAG: "Ok",
                  _0: addNewMacroModule(st)
                };
        });
  };
  var rndError = function (msg) {
    return React.createElement("pre", undefined, msg);
  };
  var rndExpBtn = function () {
    return React.createElement("a", {
                style: expBtnBaseStyle,
                onClick: (function (param) {
                    setIsExpanded(function (prev) {
                          return !prev;
                        });
                  })
              }, isExpanded ? "-" : "+");
  };
  var rndMacrosDropdown = function () {
    return React.createElement(Expln_React_Row.make, {
                children: Caml_option.some(null)
              }, React.createElement(FormControl, {
                    size: "small",
                    children: Caml_option.some(React.createElement(Select, {
                              sx: {
                                width: 330
                              },
                              value: state.selectedMacroModuleName,
                              onChange: Expln_React_common.evt2str(actSelectedMacroModuleNameChange),
                              children: Caml_option.some(Belt_MapString.toArray(state.macroModules).map(function (param) {
                                        var modName = param[0];
                                        var dispName = modName + (
                                          param[1].isActive ? "" : " (inactive)"
                                        );
                                        return JsxPPXReactSupportU.createElementWithKey(modName, MenuItem, {
                                                    value: modName,
                                                    children: Caml_option.some(dispName)
                                                  });
                                      }))
                            }))
                  }), rndExpBtn());
  };
  var rndCancelBtn = function () {
    return React.createElement(Expln_React_Row.make, {
                children: Caml_option.some(null)
              }, React.createElement(Button, {
                    onClick: (function (param) {
                        onClose();
                      }),
                    variant: "outlined",
                    children: "Cancel"
                  }), isExpanded ? null : MM_react_common.rndHiddenTextField(undefined, MM_react_common.kbrdHnds([MM_react_common.kbrdClbkMake(MM_react_common.keyEsc, undefined, undefined, undefined, onClose)])));
  };
  var rndScriptTextField = function (modName, selectedMacroModule) {
    return JsxPPXReactSupportU.createElementWithKey(modName, TextField, {
                value: selectedMacroModule.scriptTextEdit,
                label: "Script",
                size: "small",
                style: {
                  width: selectedMacroModuleIsReadOnly ? "350px" : "300px"
                },
                multiline: true,
                maxRows: 3,
                onChange: Expln_React_common.evt2str(actSetScriptTextEdit),
                onKeyDown: MM_react_common.kbrdHnds([
                      MM_react_common.kbrdClbkMake(MM_react_common.keyEnter, undefined, undefined, undefined, actSaveEdits),
                      MM_react_common.kbrdClbkMake(MM_react_common.keyEsc, undefined, undefined, undefined, onClose)
                    ]),
                disabled: selectedMacroModuleIsReadOnly,
                autoFocus: true
              });
  };
  var rndEditControls = function () {
    if (!isExpanded || selectedMacroModule === undefined) {
      return null;
    } else {
      return React.createElement(Expln_React_Column.make, {
                  children: Caml_option.some(null)
                }, React.createElement(TextField, {
                      value: selectedMacroModule.nameEdit,
                      label: "Module name",
                      size: "small",
                      style: {
                        width: "350px"
                      },
                      onChange: Expln_React_common.evt2str(actSetNameEdit),
                      onKeyDown: MM_react_common.kbrdHnds([
                            MM_react_common.kbrdClbkMake(MM_react_common.keyEnter, undefined, undefined, undefined, actSaveEdits),
                            MM_react_common.kbrdClbkMake(MM_react_common.keyEsc, undefined, undefined, undefined, onClose)
                          ]),
                      disabled: selectedMacroModuleIsReadOnly
                    }), React.createElement(FormControlLabel, {
                      control: React.createElement(Checkbox, {
                            checked: selectedMacroModule.isActiveEdit,
                            onChange: Expln_React_common.evt2bool(actSetIsActiveEdit)
                          }),
                      label: "Active"
                    }), selectedMacroModuleIsReadOnly ? rndScriptTextField(state.selectedMacroModuleName, selectedMacroModule) : React.createElement("table", undefined, React.createElement("tbody", undefined, React.createElement("tr", undefined, React.createElement("td", undefined, React.createElement(IconButton, {
                                        onClick: (function (param) {
                                            actShowWarning();
                                          }),
                                        color: "orange",
                                        title: "Security warning",
                                        children: Caml_option.some(React.createElement(Warning, {}))
                                      })), React.createElement("td", {
                                    style: {
                                      paddingLeft: "5px"
                                    }
                                  }, rndScriptTextField(state.selectedMacroModuleName, selectedMacroModule))))), React.createElement(Expln_React_Row.make, {
                      children: Caml_option.some(null)
                    }, React.createElement(Button, {
                          onClick: (function (param) {
                              actSaveEdits();
                            }),
                          variant: "contained",
                          disabled: !thereAreChangesInSelectedMacroModule,
                          children: "Save changes"
                        }), React.createElement(Button, {
                          onClick: (function (param) {
                              actAddNewMacroModule();
                            }),
                          variant: "outlined",
                          children: "Add new"
                        }), React.createElement(Button, {
                          onClick: (function (param) {
                              actDeleteSelectedMacroModule();
                            }),
                          variant: "outlined",
                          disabled: selectedMacroModuleIsReadOnly,
                          children: "Delete"
                        })));
    }
  };
  var rndActiveMacros = function () {
    if (selectedMacroModule === undefined) {
      return rndError("Cannot find a module of macros with name \"" + state.selectedMacroModuleName + "\"");
    }
    var msg = selectedMacroModule.scriptExecutionErr;
    if (msg !== undefined) {
      return rndError("There was an error during initialization of this module of macros:\n" + msg);
    } else if (selectedMacroModule.isActive) {
      if (selectedMacroModule.macros.length === 0) {
        return "This module has no registered macros.";
      } else {
        return JsxPPXReactSupportU.createElementWithKey(state.selectedMacroModuleName, List, {
                    disablePadding: true,
                    children: Caml_option.some(selectedMacroModule.macros.map(function (macroName) {
                              return JsxPPXReactSupportU.createElementWithKey(macroName, ListItem, {
                                          disablePadding: true,
                                          children: Caml_option.some(React.createElement(ListItemButton, {
                                                    onClick: (function (param) {
                                                        onClose();
                                                        MM_api_macros.runMacro(state.selectedMacroModuleName, macroName);
                                                      }),
                                                    children: Caml_option.some(React.createElement(ListItemText, {
                                                              children: Caml_option.some(macroName)
                                                            }))
                                                  }))
                                        });
                            }))
                  });
      }
    } else {
      return React.createElement(Button, {
                  onClick: (function (param) {
                      activateSelectedMacroModule();
                    }),
                  variant: "contained",
                  children: "Activate"
                });
    }
  };
  return function () {
    return React.createElement(Paper, {
                style: {
                  padding: "10px"
                },
                children: Caml_option.some(React.createElement(Expln_React_Column.make, {
                          children: Caml_option.some(null)
                        }, rndMacrosDropdown(), rndEditControls(), rndActiveMacros(), rndCancelBtn()))
              });
  };
}

function MM_cmp_macros(props) {
  var modalRef = props.modalRef;
  var match = React.useState(function () {
        
      });
  var setState = match[1];
  var state = match[0];
  React.useEffect((function () {
          readStateFromLocStor().then(function (st) {
                setState(function (param) {
                      return st;
                    });
              });
        }), []);
  var updateState = function (update) {
    setState(function (st) {
          if (st === undefined) {
            return ;
          }
          var msg = update(st);
          if (msg.TAG === "Ok") {
            return msg._0;
          }
          MM_react_common.openInfoDialog(modalRef, undefined, undefined, Caml_option.some(msg._0), undefined, undefined, undefined, undefined, undefined);
          return st;
        });
  };
  var updateSelectedMacroModule = function (update) {
    updateState(function (st) {
          var match = Belt_MapString.get(st.macroModules, st.selectedMacroModuleName);
          if (match !== undefined) {
            return update(st, st.selectedMacroModuleName);
          } else {
            return {
                    TAG: "Error",
                    _0: "Cannot find a module with name \"" + st.selectedMacroModuleName + "\""
                  };
          }
        });
  };
  var updateStateAsync = function (update) {
    setState(function (st) {
          if (st !== undefined) {
            update(st).then(function (updateResult) {
                  if (updateResult.TAG === "Ok") {
                    var st$1 = updateResult._0;
                    return setState(function (param) {
                                return st$1;
                              });
                  }
                  MM_react_common.openInfoDialog(modalRef, undefined, undefined, Caml_option.some(updateResult._0), undefined, undefined, undefined, undefined, undefined);
                  setState(function (param) {
                        return st;
                      });
                });
            return ;
          }
          
        });
  };
  var updateSelectedMacroModuleAsync = function (update) {
    updateStateAsync(function (st) {
          var match = Belt_MapString.get(st.macroModules, st.selectedMacroModuleName);
          if (match !== undefined) {
            return update(st, st.selectedMacroModuleName);
          } else {
            return Promise.resolve({
                        TAG: "Error",
                        _0: "Cannot find a module with name \"" + st.selectedMacroModuleName + "\""
                      });
          }
        });
  };
  var stateForRenderer = state !== undefined ? state : ({
        selectedMacroModuleName: "",
        macroModules: undefined
      });
  var stateRenderer = useStateRenderer(modalRef, stateForRenderer, updateState, updateSelectedMacroModule, updateStateAsync, updateSelectedMacroModuleAsync, props.onClose);
  if (state !== undefined) {
    return stateRenderer();
  } else {
    return "Loading...";
  }
}

var make = MM_cmp_macros;

exports.scriptCache = scriptCache;
exports.getScriptCacheKey = getScriptCacheKey;
exports.runAsyncScript = runAsyncScript;
exports.removeStaleDataFromScriptCache = removeStaleDataFromScriptCache;
exports.textToScript = textToScript;
exports.showIncompleteMacros = showIncompleteMacros;
exports.predefinedMacroModuleScripts = predefinedMacroModuleScripts;
exports.isPredefinedMacroModule = isPredefinedMacroModule;
exports.stateToStateLocStor = stateToStateLocStor;
exports.makeEmptyStateLocStor = makeEmptyStateLocStor;
exports.macrosLocStorKey = macrosLocStorKey;
exports.runActiveScripts = runActiveScripts;
exports.readStateFromLocStor = readStateFromLocStor;
exports.reloadState = reloadState;
exports.addNewMacroModule = addNewMacroModule;
exports.deleteMacroModule = deleteMacroModule;
exports.saveEdits = saveEdits;
exports.setNameEdit = setNameEdit;
exports.setIsActiveEdit = setIsActiveEdit;
exports.setScriptTextEdit = setScriptTextEdit;
exports.resetEditsForMacroModule = resetEditsForMacroModule;
exports.setSelectedMacroModuleName = setSelectedMacroModuleName;
exports.expBtnBaseStyle = expBtnBaseStyle;
exports.warningText = warningText;
exports.useStateRenderer = useStateRenderer;
exports.make = make;
/* scriptCache Not a pure module */
